import type { FC } from "react";
import React, { memo, useRef } from "react";
import clsx from "clsx";
import styles from "./InteriorSlider.module.scss";
import { useSlider } from "../../../../../../../../common-deprecated/features/apheleia/hooks/useSlider";
import type { ImageCarConfigOverrideType } from "../../../../../hooks/useAphVisual";
import { useInteriorCarImages } from "../../../../../hooks/useAphVisual";

const InteriorSlider: FC<{
    fullHeight?: boolean;
    overrideCarConfig?: ImageCarConfigOverrideType; // When this is added, the carConfig from CCIS will be overridden with a custom config. Used for availableInOtherGrades.
    enabled?: boolean;
}> = ({ fullHeight, overrideCarConfig, enabled }) => {
    const interiorImages = useInteriorCarImages([1, 0, 2], !!enabled, {
        width: 1280,
        height: 1280,
        useAvailableInOtherGradeImages: overrideCarConfig && {
            overrideCarImageInput: overrideCarConfig?.imageCarConfig,
            overrideCarIds: overrideCarConfig?.carIds,
        },
        srcSet: [
            { width: 1920, height: 1920 },
            { width: 2560, height: 2560 },
            { width: 3200, height: 3200 },
        ],
    });
    const wrapperRef = useRef<HTMLDivElement | null>(null);
    const anyItemRef = useRef<HTMLImageElement | null>(null);
    const { isDragging, elementProps, currentSlide } = useSlider(wrapperRef, anyItemRef);

    return (
        <div className={clsx(styles["slider-container"], fullHeight && styles["full-height"])}>
            <div className={clsx(styles.slider, isDragging && styles.dragging)} ref={wrapperRef} {...elementProps}>
                {interiorImages?.map((frame, index: number) => (
                    <img
                        ref={index === 0 ? anyItemRef : undefined}
                        key={frame.src}
                        className={styles["slider-item"]}
                        src={frame.src}
                        srcSet={frame.srcSet}
                        alt=""
                        loading="lazy"
                    />
                ))}
            </div>
            <div className={styles["slider-bullets"]}>
                {Array(interiorImages.length)
                    .fill(0)
                    .map((_, index) => (
                        // This index is fixed
                        // eslint-disable-next-line react/no-array-index-key
                        <div key={index} data-active={currentSlide === index} aria-hidden="true" />
                    ))}
            </div>
        </div>
    );
};

export default memo(InteriorSlider);
